<template>
  <div id="app">
    <navbar v-if="$route.name !== '404'">
      <div class="row">
        <div class="col col-sm-6">
          <a target="_blank" class="navbar-brand" slot="brand" :href="companyLink">{{ companyName[$route.name] }}</a>
        </div>
        <div class="col col-sm-6">
          <a target="_blank" href="https://xn--virtuaalettevte-4sb.ee/" class="pull-right" style="margin-top: 9px;">
            <img
              :src="produxioIcon"
              alt=""
            >
          </a>
        </div>
      </div>
    </navbar>
    <router-view></router-view>
  </div>
</template>

<script>
import { Navbar } from "uiv"
import produxioIcon from './assets/produxioIcon'

export default {
  name: "app",
  components: { Navbar },
  data() {
    return {
      companyName: {
        plasma: 'PlasmaPro',
        plasmapro: 'PlasmaPro',
        adrem: 'Adrem',
        lapi: 'Lapi MT'
      },
      produxioIcon
    }
  },
  computed: {
    companyLink () {
      switch(this.$route.name) {
        case 'lapi':
          return 'https://www.lapimetall.ee/'
        case 'plasmapro':
          return 'https://www.plasmapro.ee/'
        default:
          return ''
      }
    }
  }
};
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }
  .navbar-header button {
    display: none;
  }
</style>
